const router = [
  {
    path: '/satisfaction-rate-list',
    name: 'SatisfactionRateList',
    component: () => import('../views/SatisfactionRate/SatisfactionRateList.vue')
  },
  {
    path: '/satisfaction-rate-info',
    name: 'SatisfactionRateInfo',
    component: () => import('../views/SatisfactionRate/SatisfactionRateInfo.vue')
  },
  {
    path: '/satisfaction-rate',
    name: 'SatisfactionRate',
    component: () => import('../views/SatisfactionRate/SatisfactionRate.vue')
  },
]

export default router
